<template>
    <div id="overlayHeader">
        <h1>{{title}}</h1>
    </div>
</template>

<script>
export default {
    name: "OverlayHeader",
    props: ["title"]
}
</script>

<style>
    #overlayHeader {
        height: 72px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-bottom: solid 1px black;
    }
</style>